import { render } from "./CInputCurrency.vue?vue&type=template&id=79e45fd1"
import script from "./CInputCurrency.vue?vue&type=script&lang=js"
export * from "./CInputCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__